import { Component } from '@angular/core';
import {ButtonComponent} from "src/app/common/button/button.component";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgClass} from "@angular/common";
import {SpinnerComponent} from "src/app/common/spinner/spinner.component";
import {AuthService} from "src/app/services/Auth/auth.service";
import {Router, RouterLink} from "@angular/router";
import {PasswordToggleComponent} from "src/app/common/password-toggle/password-toggle.component";

@Component({
    selector: 'app-password-update',
    imports: [
        ButtonComponent,
        ReactiveFormsModule,
        NgClass,
        SpinnerComponent,
        PasswordToggleComponent,
        RouterLink
    ],
    templateUrl: './password-update.component.html',
    styleUrl: './password-update.component.scss'
})
export class PasswordUpdateComponent {
  loading: boolean = false;
  form!: FormGroup;
  regex_length = /^.{8,20}$/
  regex_capital = /[A-Z]+/
  regex_number = /[0-9]+/
  regex_special = /[!@#$%^&*()\-=_+()]+/
  error: string = '';
  show_password: boolean = false;
  show_password_confirm: boolean = false;

  constructor(private fb: FormBuilder,
              private auth: AuthService,
              private router: Router) {
    this.initForm();
  }
  ngOnInit(){
    if(!this.auth.forceChange()){
      this.router.navigate([this.auth.getRoleIndex()]);
    }
  }
  initForm(){
    this.form = this.fb.group({
      old_password:     ['', [Validators.required,Validators.minLength(8),Validators.maxLength(20)]],
      new_password:     ['', [Validators.required,Validators.minLength(8),Validators.maxLength(20)]],
      confirm_password: ['' ,[Validators.required,Validators.minLength(8),Validators.maxLength(20)]]
    });
  }
  apiSave(password: string,old_password: string){
    this.error = '';
    this.loading = true;
    this.form.disable();
    this.auth.changeSelfPassword(password,old_password,true).subscribe({
      error: err => this.onError(err),
      complete: () => this.onSuccess()
    });
  }
  getNewPassword(){
    return this.form.controls['new_password'].value;
  }
  passwordMatch(){
    if(this.form.controls['new_password'].invalid ||  this.form.controls['confirm_password'].invalid ){
      return false;
    }
    return this.form.controls['new_password'].value == this.form.controls['confirm_password'].value;
  }
  isComplete(){
    const password =  this.form.controls['new_password'].value;
    const confirm_password =  this.form.controls['confirm_password'].value;
    if(this.form.invalid){
      return  false;
    }
    if(password!=confirm_password){
      return false;
    }
    if(!this.regex_length.test(password)){
      return false;
    }
    if(!this.regex_capital.test(password)){
      return false;
    }
    if(!this.regex_number.test(password)){
      return false;
    }
    return this.regex_special.test(password);

  }
  onSuccess(){
    this.auth.unsetForceChange();
    this.router.navigate([this.auth.getRoleIndex()]);
  }
  save(){
    const values = this.form.getRawValue();
    this.apiSave(values.new_password,values.old_password);
  }
  onError(err: any){
    console.log(err);

    if (err.status==403){
      this.error = 'Invalid Current Password';
    }else{
      this.error = 'Unable to Update Password. Please contact your administrator.';
    }
    this.loading = false;
    this.form.enable();
  }

}
